"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _ErvBottomBar = _interopRequireDefault(require("./ErvBottomBar.scss"));

var _Constants = require("../../constants/Constants");

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _ObjectHelper = require("../../../helpers/ObjectHelper");

var _ColorHelper = require("../../../helpers/ColorHelper");

var _Image = _interopRequireDefault(require("../Image/Image"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../helpers/CordovaFileHelper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _FlexMenuHelper = require("../../../helpers/FlexMenuHelper");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _LogService = require("../../../KESI2/Services/LogService");

var _strings = require("../../../../config/strings");

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

var _AppCordovaGeneric = _interopRequireDefault(require("../AppCordova/AppCordovaGeneric.scss"));

var _PreconditionActionExecutioner = require("../../../utils/PreconditionActionExecutioner");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var ErvBottomBar = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(ErvBottomBar, _DataStoreComponent);

  var _super = _createSuper(ErvBottomBar);

  function ErvBottomBar(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, ErvBottomBar);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkIfContentAvailable", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var hasContent;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getContent();

            case 2:
              hasContent = _context.sent;
              console.log('hasContent', hasContent);

              if (!hasContent || hasContent.length === 0) {
                document.documentElement.style.setProperty('--bottomBarHeightPx', '0px');
                document.documentElement.style.setProperty('--bottomBarHeight', '0');
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sortContent", function (contents) {
      if (_config["default"].sortById) {
        return contents.sort(function (content1, content2) {
          return content1.id - content2.id;
        });
      }

      if (_config["default"].sortByOrderField) {
        return contents.sort(function (content1, content2) {
          if ((content1.order || content1.order === 0) && (content2.order || content2.order === 0)) {
            if (content1.order < content2.order) {
              return -1;
            }

            if (content1.order > content2.order) {
              return 1;
            }

            return 0;
          } else {
            // Don't bring up id sorting here!
            // This piece of code is used for lecture-in-spoc sorting, too and we want to keep the author's order there
            return 0;
          }
        });
      }

      return 0;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getContent", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var courses, sortedCourses, filteredCourses, homeRegionCode, spocs, sortedSpocs, filteredSpocs, _homeRegionCode;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_config["default"].usesCourses) {
                _context2.next = 13;
                break;
              }

              _context2.next = 3;
              return _KESI2Helper["default"].getAllCourseData();

            case 3:
              courses = _context2.sent;
              sortedCourses = _this.sortContent(courses);
              filteredCourses = _this.getFilteredSpocs(courses);
              homeRegionCode = _this.state.data[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE];

              _this.getBulkTileDataFromFlexMenu(sortedCourses, [_config["default"].rootId], homeRegionCode);

              console.log('filteredCourses', filteredCourses);

              _this.setState({
                courses: sortedCourses,
                filteredCourses: filteredCourses
              });

              return _context2.abrupt("return", filteredCourses);

            case 13:
              _context2.next = 15;
              return _KESI2Helper["default"].getAllSpocData();

            case 15:
              spocs = _context2.sent;
              sortedSpocs = _this.sortContent(spocs);
              filteredSpocs = _this.getFilteredSpocs(spocs);
              _homeRegionCode = _this.state.data[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE];

              _this.getBulkTileDataFromFlexMenu(sortedSpocs, [_config["default"].rootId], _homeRegionCode);

              _this.setState({
                spocs: sortedSpocs,
                filteredSpocs: filteredSpocs
              });

              return _context2.abrupt("return", filteredSpocs);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getFilteredSpocs", function (spocs) {
      var filteredSpocs = [];
      var isCustomerVersion = _config["default"].isSafetureApp ? _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_IS_CUSTOMER_VERSION) || false : false;
      spocs.forEach(function (spoc) {
        if ((0, _PreconditionChecker.getFailingPrecondition)(spoc.showPrecondition)) {
          return null;
        } else if (_config["default"].usesCourses && spoc.keyword === 'hidden') {
          return null;
        } else if (isCustomerVersion) {
          var tileData = _this.state.tileData[spoc.id];
          console.log('tileData', tileData);

          if (tileData && tileData.isVisibleForCustomers === false) {
            return null;
          } else {
            filteredSpocs.push(spoc);
          }
        } else {
          filteredSpocs.push(spoc);
        }
      });
      return filteredSpocs;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getBulkTileDataFromFlexMenu", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(content, pathArray, homeRegionCode) {
        var homeRegion, tileData, promises;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_config["default"].usesFlexMenu) {
                  _context4.next = 8;
                  break;
                }

                homeRegion = _config["default"].tcCountryHelper ? _config["default"].tcCountryHelper.getRegionNameByCode(homeRegionCode) : homeRegionCode;
                tileData = _this.state.tileData;
                promises = content.map( /*#__PURE__*/function () {
                  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(tile) {
                    return _regenerator["default"].wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return (0, _FlexMenuHelper.getFlexMenuData)([].concat((0, _toConsumableArray2["default"])(pathArray), [tile.id]), homeRegion);

                          case 2:
                            tileData[tile.id] = _context3.sent;

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x4) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                _context4.next = 6;
                return _promise["default"].all(promises);

              case 6:
                _this.setState({
                  tileData: tileData
                });

                _this.forceUpdate();

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x, _x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(content, path, belongsToTargetAndIsAlreadyActive) {
        var force,
            failingPrecondition,
            continueOnFail,
            bottomBar,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                force = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : false;

                if (!(content.openPrecondition && !force)) {
                  _context5.next = 7;
                  break;
                }

                failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.openPrecondition);
                continueOnFail = (0, _PreconditionChecker.continueIfPreconditionFailed)(failingPrecondition);

                if (!failingPrecondition) {
                  _context5.next = 7;
                  break;
                }

                (0, _PreconditionActionExecutioner.preconditionAction)(failingPrecondition, continueOnFail ? _this.onOpen(content, path, belongsToTargetAndIsAlreadyActive, true) : function () {});
                return _context5.abrupt("return");

              case 7:
                _this.props.setBackButtonFunc(null); // if (belongsToTargetAndIsAlreadyActive) {
                //   return
                // }


                if (_config["default"].openTilesInFullScreen) {
                  bottomBar = document.getElementById('bottomBar');

                  if (bottomBar) {
                    bottomBar.style.opacity = 1;
                    bottomBar.style.zIndex = 10000;
                  }
                }

                _NavigationManagerCordova["default"].goTo(path, belongsToTargetAndIsAlreadyActive ? "".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId) : null);

                if (_this.props.onTabClicked) {
                  _this.props.onTabClicked();
                }

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5, _x6, _x7) {
        return _ref5.apply(this, arguments);
      };
    }());
    _this.state = {
      navbar: null,
      selectedTab: _config["default"].cordovaStartUrl(),
      filteredSpocs: [],
      spocs: [],
      filteredCourses: [],
      courses: [],
      filePath: _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder(),
      tileData: {},
      openPath: _config["default"].cordovaStartUrl()
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(ErvBottomBar.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE, _DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE, _DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED, _DataStore.DATA_STORE_PATHS.ERGO_USER_DATA, _DataStore.DATA_STORE_PATHS.ERGO_RECRUITING_ACTIVATED, _DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, _DataStore.DATA_STORE_PATHS.TC_IS_CUSTOMER_VERSION]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(ErvBottomBar.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['navbar', 'currentTheme']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(ErvBottomBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkIfContentAvailable();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (_config["default"].usesFlexMenu && this.state.data[_DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE] && prevState.data[_DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE] !== this.state.data[_DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE]) {
        this.getBulkTileDataFromFlexMenu(prevState.spocs, [_config["default"].rootId], this.state.data[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE], this.state.data[_DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE]);
      }

      if (this.state.data[_DataStore.DATA_STORE_PATHS.TC_IS_CUSTOMER_VERSION] && !prevState.data[_DataStore.DATA_STORE_PATHS.TC_IS_CUSTOMER_VERSION]) {
        this.getContent();
      }

      if (_config["default"].isErgoApp && this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED] !== prevState.data[_DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED]) {
        console.log('ERVBottomBar ergoActivated', this.state.data);
        this.getContent();
      }

      if (_config["default"].isErgoApp && this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA] !== prevState.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA]) {
        console.log('ERVBottomBar ergoActivated', this.state.data);
        this.getContent();
      }

      if (this.state.data[_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE] !== prevState.data[_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE]) {
        this.getContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.documentElement.style.removeProperty('--bottomBarHeightPx');
      document.documentElement.style.removeProperty('--bottomBarHeight');
    } // TODO: tidy up, make target independent

  }, {
    key: "getStyles",
    value: function getStyles() {
      var theme = null;

      if (this.state.navbar && this.state.currentTheme in this.state.navbar) {
        theme = this.state.navbar[this.state.currentTheme];
      }

      var defaultTheme = this.state.navbar ? this.state.navbar["default"] : null;
      var style = {
        color: (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarText', defaultTheme, 'navbarText', _ColorHelper.COLOR.BLACK),
        zIndex: _Constants.GLOBAL_Z_INDEXES.navbar,
        position: 'absolute',
        overflow: 'hidden'
      };
      return {
        bottomBar: style
      };
    }
  }, {
    key: "renderIconForContent",
    value: function renderIconForContent(content) {
      var _this2 = this;

      var currentPath;

      if (_NavigationManagerCordova["default"].getCurrentPath() !== _config["default"].rootId) {
        currentPath = "".concat(_config["default"].baseRoute, "/").concat(_NavigationManagerCordova["default"].getCurrentPath());
      } else {
        currentPath = _config["default"].cordovaStartUrl();
      }

      var belongsToTargetAndIsActive = currentPath === "".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId, "!").concat(content.id) || currentPath.startsWith("".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId, "!").concat(content.id, "!")) || currentPath === "".concat(_config["default"].baseRoute, "/").concat(_Constants.SETTINGS_PATH) && content.keyword === _Constants.SETTINGS_PATH || currentPath === "".concat(_config["default"].baseRoute, "/").concat(_Constants.TOPIC_CHOOSER_PATH) && content.keyword === _Constants.TOPIC_CHOOSER_PATH;

      var isCurrentActivePath = currentPath === "".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId, "!").concat(content.id) || currentPath === "".concat(_config["default"].baseRoute, "/").concat(_Constants.SETTINGS_PATH) && content.keyword === _Constants.SETTINGS_PATH || currentPath === "".concat(_config["default"].baseRoute, "/").concat(_Constants.TOPIC_CHOOSER_PATH) && content.keyword === _Constants.TOPIC_CHOOSER_PATH;

      var imgSrc;

      if (_config["default"].isNewDesign && content.newSvgIcon) {
        imgSrc = content.newSvgIcon;
      } else if (content.svgIcon) {
        imgSrc = content.svgIcon;
      } else {
        if (belongsToTargetAndIsActive) {
          imgSrc = content.icon;
        } else {
          imgSrc = content.iconUnactive;
        }
      }

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        imgSrc = "".concat(this.state.filePath).concat(imgSrc);
      }

      var titleKey = content && content.itemid ? "".concat(content.itemid, "_title") : null;
      var title = titleKey ? (0, _strings.getString)(titleKey) : null;

      if (!title || title === titleKey) {
        var tileDataTitle = this.state.tileData && this.state.tileData[content.id] ? this.state.tileData[content.id].title : null;
        title = tileDataTitle || content.title;
      }

      var multilineStyle = _config["default"].multilineTabs ? _ErvBottomBar["default"].multilineTabs : '';
      var path = "".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId, "!").concat(content.id);

      if (content.keyword === _Constants.SETTINGS_PATH) {
        path = _Constants.SETTINGS_PATH;
      } else if (content.keyword === _Constants.USER_PATH) {
        path = _Constants.USER_PATH;
      } else if (content.keyword === _Constants.TOPIC_CHOOSER_PATH) {
        path = _Constants.TOPIC_CHOOSER_PATH;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: content.id,
        className: "".concat(_ErvBottomBar["default"].container, " ").concat(multilineStyle),
        style: _config["default"].usesCourses ? {
          width: "".concat(this.state.filteredCourses.length > 0 ? 100 / this.state.filteredCourses.length : 20, "%")
        } : {
          width: "".concat(this.state.filteredSpocs.length > 0 ? 100 / this.state.filteredSpocs.length : 20, "%")
        },
        onClick: function onClick() {
          _this2.onOpen(content, path, isCurrentActivePath);
        }
      }, content.id === '3962' ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '15px',
          height: '15px',
          backgroundColor: 'red',
          borderRadius: '50%',
          position: 'absolute',
          top: '-7px',
          right: '60px'
        }
      }) : null, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: 'Menüicon',
        src: imgSrc,
        className: "".concat(belongsToTargetAndIsActive ? _ErvBottomBar["default"].iconActive : _ErvBottomBar["default"].iconUnactive, " ").concat(_config["default"].hideTitleInBottomBar ? _ErvBottomBar["default"].noTitle : '')
      }), _config["default"].hideTitleInBottomBar ? null : /*#__PURE__*/_react["default"].createElement("p", {
        className: _ErvBottomBar["default"].title,
        style: belongsToTargetAndIsActive ? {
          color: _cssConstants["default"].colors.bottomBarActive
        } : {
          color: _cssConstants["default"].colors.bottomBarInactive
        }
      }, title));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var dynamicStyles = this.getStyles();
      var icons = _config["default"].usesCourses ? this.state.filteredCourses.map(function (course) {
        return _this3.renderIconForContent(course);
      }) : this.state.filteredSpocs.map(function (spoc) {
        return _this3.renderIconForContent(spoc);
      });
      if (icons.length === 0) return null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvBottomBar["default"].bottomBar,
        style: dynamicStyles.bottomBar,
        id: 'bottomBar'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '100%'
        }
      }, icons));
    }
  }]);
  return ErvBottomBar;
}(_DataStoreComponent2["default"]);

exports["default"] = ErvBottomBar;
ErvBottomBar.propTypes = {
  renderUpdateValue: _propTypes["default"].number,
  onTabClicked: _propTypes["default"].func,
  setBackButtonFunc: _propTypes["default"].func
};
ErvBottomBar.defaultProps = {
  title: '',
  sidebarWidth: '0',
  sidebarDocked: 0,
  onMenuClicked: null,
  onRefresh: null,
  isTraining: false
};